/** @format */

import React from 'react'

import {UpgradeLink} from '@src/components/tailwind/UpgradeLink'

import {formatResetDate, pluralize} from './utils'

type ReprocessRefusalProps = {
  // ISO date the monthly limit resets on
  limitResetsOn: string
  // null means no finite limit, so there's no reset to mention
  monthlyLimit: number | null
  // room left in the limit this month
  remaining: number
  // how many submissions were selected for reprocessing
  requested: number
}

/**
 * Why a reprocess request is refused before it is sent: the selection is
 * bigger than the room left in the monthly limit.
 */
export function ReprocessRefusal(props: ReprocessRefusalProps) {
  const {limitResetsOn, monthlyLimit, remaining, requested} = props
  const reset =
    monthlyLimit == null
      ? ''
      : ` (resets to ${monthlyLimit} on ${formatResetDate(limitResetsOn)})`
  const upgrade = (
    <UpgradeLink
      className="primaryLink font-bold"
      feature="account_monthly_submissions"
    >
      Upgrade to raise your monthly submission limit
    </UpgradeLink>
  )
  return (
    <>
      <span className="block">
        You selected <strong>{requested}</strong>{' '}
        {pluralize(requested, 'submission')}, but you{' '}
        {remaining === 0 ? (
          <>
            have <strong>none</strong>
          </>
        ) : (
          <>
            only have <strong>{remaining}</strong>
          </>
        )}{' '}
        left in your monthly submission limit{reset}.
      </span>
      <span className="mt-4 block">
        {remaining === 0 ? upgrade : <>Select fewer, or {upgrade}</>}.
      </span>
    </>
  )
}
